WiseMetering.Model.IntegrationPartner = WiseMetering.Model.extend({
    getJsonFormatted: function() {
        const json = this.toJSON();
        const descriptionKey = `integration_partners.partners.${this.get('slug')}.description`;
        const benefitsKey = `integration_partners.partners.${this.get('slug')}.benefits`;

        json.description = i18next.exists(descriptionKey) ? i18next.t(descriptionKey) : 'n/a';
        json.benefits = i18next.exists(benefitsKey) ? i18next.t(benefitsKey) : 'n/a';
        json.default_plan = this.plans('default_plan') || i18next.t(`integration_partners.no_default_plan`);
        json.plan_requirement = this.plans('plan_requirement') || i18next.t(`integration_partners.no_plan_requirement`);

        return json;
    },

    getIndexURL: function() {
        const license = WiseMetering.integrationLicenses.findWhere({ partner_id: this.id });

        if (license) {
            return `/integration_licenses/${license.id}`;
        } else {
            return '/map';
        }
    },

    getClassName: function() {
        let capitalise = word => word.charAt(0).toUpperCase() + word.slice(1);
        return this.get('slug').split('_').map(word => capitalise(word)).join('');
    },

    plans: function() {
        const planName = WiseMetering.plans.get(this.get('default_plan_id')).get('slug');

        if (planName === 'essentials') {
            return 'Essentials, Standard, Advanced and Premium';
        } else if (planName === 'standard') {
            return 'Standard, Advanced and Premium';
        } else if (planName === 'advanced') {
            return 'Advanced and Premium';
        } else if (planName === 'premium') {
            return 'Premium';
        }
    }
});
